import { ComponentType } from 'react'
import { Search, Design, ImageAdd, Camera1, Microphone, DotHorizontal, Caption } from 'blaze-ui/icons/20'
import { Image03 } from 'blaze-ui/icons/24'
import { MediaStrip } from 'blaze-ui/icons/20/MediaStrip'

export const STEP_ICONS: Record<string, ComponentType<{ size?: number; color?: string }>> = {
  selecting_image: Search,
  planning_design: Design,
  generating_image: Image03,
  generating_remaining: ImageAdd,
  generating_shots: Camera1,
  generating_segments: MediaStrip,
  adding_audio: Microphone,
  animating: DotHorizontal,
  writing_caption: Caption,
}
